import Head from 'next/head'
import LoginForm from '../components/forms/login-form/LoginForm'

export default function Home() {
  return (
    <>
      <Head>
        <meta name="theme-color" content="#7814E4"></meta>
        <title> Welcome to Raptures - Enjoy Free African Comics </title>
      </Head>
      <LoginForm />
    </>
  )
}
